
import { useEffect, useState } from "react";

function Section({ tab, setTab, answer, setAns, textContent }) {

  const [steps, setSteps] = useState([]);

  useEffect(() => {
      setSteps(textContent?.careers?.steps || []);
  }, [textContent?.careers?.steps]);
  
  return (
    <section
      className={`tab-content ${tab === 5 ? "active" : ""}`}
      id="tab-mission"
    >
      <section className="section-content">
        <div className="section-text" style={{ textAlign: "center" }}>
          <br />
          <h2>{textContent?.careers?.title}</h2>
          <div className="careers-list">
            {steps.map((job, index) => (
              <div key={index} className="career-item">
                <h3>{job.title}</h3>
                <p>{job.description}</p>
              </div>
            ))}
          </div>
          <br />
          <h1>{textContent?.careers?.jobCallToAction?.title}</h1>
          <button
            onClick={() => setAns(true)}
            className="cta-button"
            style={{ marginBottom: 25 }}
          >
            {textContent?.careers?.jobCallToAction?.options?.label}
          </button>
          <h1 style={{ display: `${answer ? "" : "none"}` }}>
            {textContent?.careers?.jobCallToAction?.message}{" "}
            <strong>
              <a
                href="https://forms.office.com/Pages/ResponsePage.aspx?id=DUlaO-FALUSu1uiKYaiVBhNxeGCKupdKncTdduLPcB9UN09SUFdIWUpZTFVQNVJRWEpFMkdVVlRFTS4u"
                style={{ textDecoration: "underline" }}
              >
                {textContent?.careers?.jobCallToAction?.button?.label}
              </a>
            </strong>
          </h1>
        </div>
      </section>
    </section>
  );
}

export default Section;
